import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import { setModal } from "../../../../../actions/index";
import Access from '../mods/modal/Access';

let timeoutModal = null;
function AccessWrapper() {
  const dispatch = useDispatch();
  const isReady = useSelector( state => state.api )
  const isConnected = useSelector( state => state.isConnected )

  const showAccess = useCallback(() => {
    timeoutModal = setTimeout(() => {
      dispatch(setModal({
        content: <Access />,
        underlayClickExits: false
      }));
    }, 3000);
  }, [dispatch])

  // Access Management
  useEffect(() => {
    if (!isConnected && isReady) {
      showAccess();
    } else {
      clearTimeout(timeoutModal);
      dispatch(setModal(null));
    }
  }, [isConnected, isReady, showAccess, dispatch])

  return null;
}

export default AccessWrapper;
